// Pre-selects every Kaching upsell (pillowcase upgrade, free gift) when it is shown,
// like the reference store. Kaching may reset its state while it finishes loading, so
// each upsell is re-checked for a few seconds after it becomes visible. Once the shopper
// touches an upsell, their choice is never overridden.
(() => {
  if (window.__pwPreselect) return;
  const state = (window.__pwPreselect = { clicks: 0 });
  const SELECTED = 'kaching-bundles__upsell__checkbox--selected';
  const WINDOW_MS = 5000;
  const firstSeen = new WeakMap();
  const lastClick = new WeakMap();
  const touched = new WeakSet();

  const markTouched = (event) => {
    if (!event.isTrusted) return;
    const upsell = event.target.closest?.('.kaching-bundles__upsell');
    const box = upsell?.querySelector('.kaching-bundles__upsell__checkbox');
    if (box) touched.add(box);
  };
  document.addEventListener('pointerdown', markTouched, true);
  document.addEventListener('keydown', markTouched, true);

  const apply = () => {
    // Background tabs throttle timers; only start counting once the shopper can see the page.
    if (document.visibilityState === 'hidden') return;
    const now = Date.now();
    document.querySelectorAll('kaching-bundle .kaching-bundles__upsell__checkbox').forEach((box) => {
      if (touched.has(box)) return;
      if (!firstSeen.has(box)) firstSeen.set(box, now);
      if (now - firstSeen.get(box) > WINDOW_MS) return;
      if (box.classList.contains(SELECTED)) return;
      if (now - (lastClick.get(box) || 0) < 900) return;
      lastClick.set(box, now);
      state.clicks += 1;
      box.click();
    });
  };

  setInterval(apply, 300);
  document.addEventListener('visibilitychange', apply);
  new MutationObserver(() => {
    clearTimeout(state.t);
    state.t = setTimeout(apply, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
